
import {createSlice} from '@reduxjs/toolkit'
import { fetchindividualJobStatus } from '../../action/master/individualJobStatusAction'

interface individualJobStatusState {
  data: any
  status: 'idle' | 'loading' | 'succeeded' | 'failed'
  error: string | null
}

const initialState: individualJobStatusState = {
  data: null,
  status: 'idle',
  error: null,
}

const individualJobStatusSlice = createSlice({
  name: 'individualJobStatus',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchindividualJobStatus.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(fetchindividualJobStatus.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.data = action.payload
        
      })
      .addCase(fetchindividualJobStatus.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message || 'Failed to fetch business type data'
      })
  },
})

export default individualJobStatusSlice.reducer
